import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Car Findeks Service
 * Araç findeks sorgulaması
 */
export const carFindeksService = {
  /**
   * Findeks phone list
   * @param {Object} payload - API payload
   * @param {string} payload.BasketId
   * @param {string} payload.CarProductId
   * @param {string} payload.IdentityNumber
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   */
  getPhoneList: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.findeks.getPhoneList,
      payload,
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Findeks phone confirmation
   * @param {Object} payload - API payload
   * @param {string} payload.BasketId
   * @param {string} payload.CarProductId
   * @param {string} payload.FindexCode
   * @param {string} payload.PINCode
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   */
  confirmFindeksPIN: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.findeks.confirmFindeksPIN,
      payload,
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Findeks phone confirmation pin renewal
   * @param {Object} payload - API payload
   * @param {string} payload.BasketId
   * @param {string} payload.CarProductId
   * @param {string} payload.FindexCode
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response

   */
  renewFindeksPIN: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.findeks.renewFindeksPIN,
      payload,
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Findeks report generation
   * @param {Object} payload - API payload
   * @param {string} payload.BasketId
   * @param {string} payload.CarProductId
   * @param {string} payload.IdentityNumber
   * @param {string} payload.BirthDate
   * @param {string} payload.DriverLicenseDate
   * @param {string} payload.Phone
   * @param {string} payload.PhoneKey
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response

   */
  generateFindeksReport: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.car.findeks.generateReport,
      payload,
      headers,
      hasErrorHandler,
    });
  },

};

